import React from 'react';
import PropTypes from 'prop-types';
import {OverlaySlider} from '@learningblocks/protocol-components';
import './style.scss';

export class Slider extends React.Component {
  onSequenceChange = (params) => {
    const {componentID, id} = this.props;
    this.props.selectSequence({
      componentID,
      sliderID: id,
      current: params,
    });
  };

  getHighlight = () => {
    let start = this.props.current.start;
    let size = this.props.current.text.length;
    return [start, size];
  };

  render() {
    return (
      <div className='slider'>
        <span className='slider-label'>{this.props.label})</span>
        <span className='slider-content'>
          <OverlaySlider
            sequence={this.props.sequence}
            highlight={this.getHighlight()}
            onChange={this.onSequenceChange}
            disable={this.props.disable}
            highlightClass={this.props.highlightClass}
          />
        </span>
      </div>
    );
  }
}

Slider.protoType = {
  answer: PropTypes.object,
  current: PropTypes.object,
  componentID: PropTypes.number,
  disable: PropTypes.bool,
  id: PropTypes.number,
  sequence: PropTypes.string,
  type: PropTypes.string,
  selectSequence: PropTypes.func,
  highlightClass: PropTypes.string,
};
